import { render } from "./Sanchan1.vue?vue&type=template&id=f1db43b2&scoped=true"
import script from "./Sanchan1.vue?vue&type=script&lang=js"
export * from "./Sanchan1.vue?vue&type=script&lang=js"

import "./Sanchan1.vue?vue&type=style&index=0&id=f1db43b2&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1db43b2"]])

export default __exports__